// Exports
export default {
	"sectionWrapper": "sectionWrapper_JRIJI"
};
